import { ButtonHTMLAttributes, ReactNode } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline'
  size?: 'small' | 'medium' | 'large'
  children: ReactNode
  as?: 'button' | 'span'
}

function Button({
  variant = 'primary',
  size = 'medium',
  children,
  className = '',
  as = 'button',
  ...props
}: ButtonProps) {
  const variantClass = `btn-${variant}`
  const sizeClass = size === 'small' ? 'btn-small' : size === 'large' ? 'btn-large' : ''
  const classes = `btn ${variantClass} ${sizeClass} ${className}`.trim()

  const Component = as

  return (
    <Component className={classes} {...(as === 'button' ? props : {})}>
      {children}
    </Component>
  )
}

export default Button
